export default (params) => ({
  trigger: {
    name: 'insurance_information.click_explanation_icon',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'fall_impact_damage',
          'water_damage',
          'manufacturing_errors',
          'theft',
          'deductible',
          'costs',
          'fire_damage',
          'damage_plan',
          'complete_plan',
          'extended_warranty',
        ],
      },
      sub_feature: {
        enum: [
          'product_page',
          'insurance_information_overlay',
        ],
      },
    },
    event: {
      name: 'select_content',
    },
    nonInt: true,
  },
});
